import { render, staticRenderFns } from "./AdditionalLiveAnswering.vue?vue&type=template&id=311929db"
import script from "./AdditionalLiveAnswering.vue?vue&type=script&lang=js"
export * from "./AdditionalLiveAnswering.vue?vue&type=script&lang=js"
import style0 from "./AdditionalLiveAnswering.vue?vue&type=style&index=0&id=311929db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports